import { isActiveMembership } from "helpers/membership-helpers";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useSubscriptionRejoinUrl } from "hooks/use-subscription-rejoin-url";
import BuyAddToBagButton from "./buy-add-to-bag";
import ProspectAddToBagButton from "./prospect-add-to-bag";
import SubscriptionAddToBagButton from "./subscription-add-to-bag";
import ClearanceAddToBagButton from "./clearance-add-to-bag";
import ReserveAddToBagButton from "./reserve-add-to-bag";
import { isSelectedSizeUnavailable, hasNoAvailableSkus } from "../helpers/availability-helper";
import RtrButton from "components/design-system/rtr-button";
import { ctaText } from "rtr-constants";

export default function AddToBag({
  availability,
  availabilityLoaded,
  membershipError,
  selectedSize,
  isBuy,
  isClearance,
  isReserve,
}) {
  const membershipState = useSelector(state => state.membershipState);
  const membershipStateLoading = useSelector(state => state.membershipStateLoading);
  const userData = useSelector(state => state.userData);
  const addresses = userData?.userProfile?.addresses;
  const staticProduct = useSelector(state => state.staticProduct);
  const isProspect = !isActiveMembership(membershipState);
  const { userCanRejoin, rejoinUrl } = useSubscriptionRejoinUrl();

  // Assume available until availability has loaded
  const styleUnavailable =
    hasNoAvailableSkus({ availabilityLoaded, availability }, staticProduct?.skus) ||
    staticProduct.stage === "UNPUBLISHED";

  const selectSizeIsUnavailable = isSelectedSizeUnavailable(selectedSize?.sku, availability);
  if ((membershipStateLoading !== false || !availabilityLoaded) && !isReserve) {
    return (
      <RtrButton
        style="primary"
        className="my-4"
        dataTestId="updp-loading-atb"
        dataHeapId="updp-loading-atb"
        loading={true}
        fullWidth>
        {ctaText.LOADING}
      </RtrButton>
    );
  }
  if (isBuy) {
    return (
      <BuyAddToBagButton
        addresses={addresses}
        selectedSize={selectedSize}
        styleUnavailable={styleUnavailable}
        selectSizeIsUnavailable={selectSizeIsUnavailable}
        staticProduct={staticProduct}
      />
    );
  } else if (isClearance) {
    return (
      <ClearanceAddToBagButton
        addresses={addresses}
        selectedSize={selectedSize}
        staticProduct={staticProduct}
        styleUnavailable={styleUnavailable}
        selectSizeIsUnavailable={selectSizeIsUnavailable}
        availabilityLoaded={availabilityLoaded}
      />
    );
  } else if (isReserve) {
    return (
      <ReserveAddToBagButton
        addresses={addresses}
        selectedSize={selectedSize}
        staticProduct={staticProduct}
        styleUnavailable={styleUnavailable}
        selectSizeIsUnavailable={selectSizeIsUnavailable}
        availabilityLoaded={availabilityLoaded}
      />
    );
  } else if (isProspect) {
    return (
      <ProspectAddToBagButton
        availability={availability}
        selectedSize={selectedSize}
        membershipState={membershipState}
        userCanRejoin={userCanRejoin}
        rejoinUrl={rejoinUrl}
      />
    );
  } else {
    return (
      <SubscriptionAddToBagButton
        addresses={addresses}
        selectedSize={selectedSize}
        staticProduct={staticProduct}
        styleUnavailable={styleUnavailable}
        selectSizeIsUnavailable={selectSizeIsUnavailable}
        availabilityLoaded={availabilityLoaded}
        membershipError={membershipError}
      />
    );
  }
}

AddToBag.propTypes = {
  availability: PropTypes.array,
  selectedSize: PropTypes.object,
  availabilityLoaded: PropTypes.bool,
  membershipError: PropTypes.object,
  isBuy: PropTypes.bool,
  isClearance: PropTypes.bool,
  isReserve: PropTypes.bool,
};
